if (!customElements.get("variant-options")) {
  customElements.define(
    "variant-options",
    class VariantOptions extends HTMLElement {
      whenLoaded = Promise.all([customElements.whenDefined("gallery-section")]);
      constructor() {
        super();
        this.addEventListener("change", this.onVariantChange);
        this.addEventListener("keydown", this.onKeyDown);

        this.container = document.querySelector(
          `section[data-product-handle="${this.getAttribute("data-product-handle")}"]`,
        );
      }

      connectedCallback() {
        this.whenLoaded.then(() => {
          this.initialize();
        }).catch(() => {
          this.initialize();
        });

        setTimeout(() => {
          if (!this.hasInitialized) {
            this.initialize();
          }
        }, 100);

        if (this.dataset.isCombined === 'true') {
          this.addEventListener('click', (event) => {
            const input = event.target.closest('input[type="radio"]');
            const listItem = event.target.closest('li');

            if (!input && !listItem) return;

            const targetInput = input || listItem?.querySelector('input[type="radio"]');
            if (targetInput?.dataset?.optionType !== 'color') {
              return;
            }

            const isChecked = input?.checked;

            if (isChecked) {
              return;
            }
            const targetHandle = listItem?.dataset?.targetHandle || input?.dataset?.targetHandle;

            if (targetHandle && targetHandle !== this.dataset.productHandle) {
              event.preventDefault();
              event.stopPropagation();

              const rootPath = window.Shopify?.routes?.root || '/';
              const targetUrl = `${window.location.origin}${rootPath}products/${targetHandle}`;
              window.location.assign(targetUrl);
            }
          }, true);
        }

        // Hacer clickable el li entero para tallas coming soon
        if (this.dataset.comingSoon === '1') {
          this.addEventListener('click', (event) => {
            const listItem = event.target.closest('li');
            if (!listItem) return;

            const comingSoonBtn = listItem.querySelector('.coming-soon-modal-open button');
            if (comingSoonBtn && event.target !== comingSoonBtn && !comingSoonBtn.contains(event.target)) {
              event.preventDefault();
              event.stopPropagation();
              comingSoonBtn.click();
            }
          });
        }
      }

      disconnectedCallback() { }

      initialize() {
        if (this.hasInitialized) {
          return;
        }

        this.hasInitialized = true;

        // DEBUG: Log all radio inputs and their data-option-type
        const allRadios = this.querySelectorAll('input[type="radio"]');
        console.log('[BRN-DEBUG] initialize() - Total radio inputs:', allRadios.length);
        allRadios.forEach((input, i) => {
          console.log(`[BRN-DEBUG] Input ${i}: name="${input.name}", value="${input.value}", data-option-type="${input.dataset.optionType}"`);
        });

        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        this.setupSizeVerification();
        this.setupLowStockTooltip();
      }

      onKeyDown(event) {
        if (event.key === "Enter" || event.keyCode === 13) {
          const input = event.target.querySelector("input");
          input?.click();
        }
      }

      onVariantChange() {
        console.log('[BRN-DEBUG] onVariantChange() called');
        const variantChangeStartEvent = new CustomEvent("variantChangeStart", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeStartEvent);
        this.updateOptions();
        this.updateMasterId();
        console.log('[BRN-DEBUG] After updateMasterId - currentVariant:', this.currentVariant);
        this.updateGallery();
        this.toggleAddButton(true, "", false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
        this.updateDropdownButtons();

        if (!this.currentVariant) {
          console.log('[BRN-DEBUG] currentVariant is null/undefined, calling setUnavailable');
          this.toggleAddButton(true, "", true);
          this.setUnavailable();
        } else {
          this.updateMedia();
          this.lenOfVariantOptions =
            document.querySelectorAll("variant-options").length;
          if (this.lenOfVariantOptions === 1) {
            this.updateURL();
          }
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }
        const variantChangeEndEvent = new CustomEvent("variantChangeEnd", {
          bubbles: true,
          composed: true,
        });
        this.dispatchEvent(variantChangeEndEvent);
      }

      updateGallery() {
        const mediaGallery = document.getElementById(
          `MediaGallery-${this.dataset.section}`,
        );

        let media_id = false;
        if (this.currentVariant && this.currentVariant.featured_media) {
          media_id = this.currentVariant.featured_media.id;
        }

        mediaGallery?.filterSlides(this.options, media_id, true);
      }

      updateDropdownButtons() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          )?.value || '';
        });

        fieldsets.forEach((fieldset) => {
          const dropdown = fieldset.querySelector(
            ".wt-product__option__dropdown",
          );
          if (dropdown) {
            const checkedInput = fieldset.querySelector('fieldset input:checked')
            if (!checkedInput) return
            const isInputDisabled = checkedInput?.classList.contains('disabled')
            dropdown.classList.toggle('wt-product__option__dropdown--unavailable', isInputDisabled)
          }
        });
      }

      updateOptions() {
        const fieldsets = Array.from(
          this.querySelectorAll(".wt-product__option"),
        );
        console.log('[BRN-DEBUG] updateOptions - fieldsets count:', fieldsets.length);

        const isCombined = this.dataset.isCombined === 'true';

        if (isCombined) {
          const variantData = this.getVariantData();
          const totalOptions = variantData?.[0]?.options?.length || 0;

          this.options = new Array(totalOptions).fill('');

          fieldsets.forEach((fieldset, visibleIndex) => {
            const inputs = Array.from(fieldset.querySelectorAll("input"));
            const checkedInput = inputs.find((radio) => radio.checked);
            const selectedValue = checkedInput?.value || "";
            console.log(`[BRN-DEBUG] updateOptions (combined) fieldset ${visibleIndex}: inputs=${inputs.length}, checkedInput=${checkedInput?.value}, selectedValue="${selectedValue}"`);

            const actualPosition = visibleIndex + 1;
            this.options[actualPosition] = selectedValue;
          });
        } else {
          this.options = fieldsets.map((fieldset, idx) => {
            const inputs = Array.from(fieldset.querySelectorAll("input"));
            const checkedInput = inputs.find((radio) => radio.checked);
            console.log(`[BRN-DEBUG] updateOptions fieldset ${idx}: inputs=${inputs.length}, checkedInput=${checkedInput?.value}`);
            return checkedInput?.value || "";
          });
        }

        this.checkedOptions = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll("input")).find(
            (radio) => radio.checked,
          ) || '';
        });

        fieldsets.forEach((fieldset, index) => {
          const selectedOption = isCombined ? this.options[index + 1] : this.options[index];

          if (!selectedOption) return;

          fieldset.querySelector(
            ".wt-product__option__title .value",
          ).innerHTML = selectedOption;
          const dropdownSpan = fieldset.querySelector(
            ".wt-product__option__dropdown span",
          );
          if (dropdownSpan) dropdownSpan.innerHTML = selectedOption;
        });
      }

      updateMasterId() {
        const isCombined = this.dataset.isCombined === 'true';
        console.log('[BRN-DEBUG] updateMasterId - isCombined:', isCombined);
        console.log('[BRN-DEBUG] updateMasterId - this.options:', this.options);

        const variantData = this.getVariantData();
        console.log('[BRN-DEBUG] updateMasterId - variantData count:', variantData?.length);

        this.currentVariant = variantData?.find((variant) => {
          return !variant.options
            .map((option, index) => {
              if (isCombined && index === 0) {
                return true;
              }
              return this.options[index] === option;
            })
            .includes(false);
        });

        console.log('[BRN-DEBUG] updateMasterId - found variant:', this.currentVariant?.id, 'available:', this.currentVariant?.available, 'qty:', this.currentVariant?.inventory_quantity, 'policy:', this.currentVariant?.inventory_policy);

        // Enforce inventory check if variant is found but has 0 quantity
        if (this.currentVariant && this.currentVariant.inventory_quantity <= 0 && this.currentVariant.inventory_policy !== 'continue') {
          console.log('[BRN-DEBUG] updateMasterId - Setting currentVariant to null due to 0 inventory');
          this.currentVariant = null;
        }

      }

      updateMedia() {
        if (!this.currentVariant) return;
        this.setAttribute("data-variant-id", this.currentVariant?.id);
        if (!this.currentVariant.featured_media) return;
        this.setAttribute(
          "data-featured-image",
          this.currentVariant?.featured_media?.preview_image?.src,
        );
        this.setAttribute(
          "data-featured-image-id",
          this.currentVariant?.featured_media?.id,
        );

        const modalContent = document.querySelector(
          `#ProductModal-${this.dataset.section} .product-media-modal__content`,
        );
        if (!modalContent) return;
        const newMediaModal = modalContent.querySelector(
          `[data-media-id="${this.currentVariant.featured_media.id}"]`,
        );
        modalContent.prepend(newMediaModal);
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === "false") return;
        window.history.replaceState(
          {},
          "",
          `${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateShareUrl() {
        const shareButton = document.getElementById(
          `Share-${this.dataset.section}`,
        );
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(
          `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
        );
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`,
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData?.filter(
          (variant) => {
            const isAvail = variant.available === true && (variant.inventory_policy === 'continue' || variant.inventory_quantity > 0);
            // console.log(`[Debug] Variant ${variant.title}: AvailFlag=${variant.available}, Qty=${variant.inventory_quantity}, Policy=${variant.inventory_policy} -> Keep? ${isAvail}`);
            return isAvail;
          }
        );
        const inputWrappers = [
          ...this.querySelectorAll(".product-form__input"),
        ];

        const isCombined = this.dataset.isCombined === 'true';

        inputWrappers.forEach((option, index) => {
          const optionInputs = [
            ...option.querySelectorAll('input[type="radio"], option'),
          ];

          // const optionName = option.dataset?.optionName;
          let actualOptionPosition = index + 1; // Default position
          let previousOptionSelected = null;

          if (isCombined) {
            // In combined listings, we need to map visible options to actual product option positions
            // Get all original product options (including hidden ones)
            const allProductOptions = this.getVariantData()?.[0]?.options || [];

            // Find the actual position of this option in the original product structure
            // We need to account for the hidden "Modelo" option
            let visibleOptionIndex = 0;
            for (let i = 0; i < allProductOptions.length; i++) {
              // Skip the "Modelo" option when counting visible options
              if (i === 0 && allProductOptions.length > 1) {
                // Assume first option is "Modelo" in combined listings
                continue;
              }

              if (visibleOptionIndex === index) {
                actualOptionPosition = i + 1;
                break;
              }
              visibleOptionIndex++;
            }

            // Find previous selected option (skip hidden Modelo)
            if (index > 0) {
              previousOptionSelected = inputWrappers[index - 1]?.querySelector(":checked")?.value;
            }
          } else {
            // Normal behavior for non-combined products
            if (index === 0 && this.currentVariant?.options.length > 1) return;
            previousOptionSelected = inputWrappers[index - 1]?.querySelector(":checked")?.value;
          }

          const availableOptionInputsValue = selectedOptionOneVariants
            .filter(
              (variant) =>
                variant.available &&
                (previousOptionSelected ? variant[`option${actualOptionPosition - 1}`] === previousOptionSelected : true),
            )
            .map((variantOption) => variantOption[`option${actualOptionPosition}`]);

          console.log(`[Debug] Option ${index} (Actual ${actualOptionPosition}): Input Values:`, optionInputs.map(i => i.value));
          console.log(`[Debug] Available Values for this option:`, availableOptionInputsValue);

          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });

        // Force enable only color options in combined listings (not sizes)
        if (isCombined) {
          setTimeout(() => {
            const allInputs = this.querySelectorAll('input[type="radio"]');
            allInputs.forEach(input => {
              if (input.dataset.optionType === 'color') {
                input.classList.remove('disabled');
              }
            });
          }, 10);
        }
      }

      setInputAvailability(listOfOptions, listOfAvailableOptions) {
        // Check if this is a single "U" size product
        const allSizeInputs = Array.from(this.querySelectorAll('input[type="radio"][data-option-type="size"]'));
        let isSingleUSizeProduct = false;

        if (allSizeInputs.length === 1) {
          const singleValue = allSizeInputs[0].value || '';
          if (singleValue.toUpperCase() === 'U') {
            isSingleUSizeProduct = true;
          }
        }

        const isComingSoon = this.dataset.comingSoon === '1';

        listOfOptions.forEach((input) => {
          // For single U size products, don't disable color options
          if (isSingleUSizeProduct) {
            if (input.dataset.optionType === 'color') {
              // Always enable color options for single U size products
              input.classList.remove("disabled");
              return;
            }
          }

          // Normal availability logic - works as before
          if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
            input.classList.remove("disabled");
            input.disabled = false;
          } else {
            input.classList.add("disabled");

            // Si el producto es "coming soon", no deshabilitar los inputs de talla
            // para que el usuario pueda hacer click y abrir el modal de aviso
            if (isComingSoon && input.dataset.optionType === 'size') {
              input.disabled = false;
            } else {
              input.disabled = true;

              // Prevenir clicks en inputs disabled
              input.addEventListener('click', function (e) {
                if (this.classList.contains('disabled') || this.disabled) {
                  e.preventDefault();
                  e.stopPropagation();
                  return false;
                }
              });
            }
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector(
          "pickup-availability",
        );
        if (!pickUpAvailability) return;

        pickUpAvailability.dataset.variantId = this.currentVariant?.id;
        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute("available");
          pickUpAvailability.innerHTML = "";
        }
      }

      removeErrorMessage() {
        const section = this.closest("section");
        if (!section) return;

        const productForm = section.querySelector("product-form");
        try {
          productForm?.handleErrorMessage();
        } catch (err) {
          console.log(err);
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant?.id;
        const sectionId = this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section;

        fetch(
          `${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`,
        )
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant?.id !== requestedVariantId) return;

            const html = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            const destination = document.getElementById(
              `price-${this.dataset.section}`,
            );
            const source = html.getElementById(
              `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuSource = html.getElementById(
              `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const skuDestination = document.getElementById(
              `Sku-${this.dataset.section}`,
            );
            const inventorySource = html.getElementById(
              `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const inventoryDestination = document.getElementById(
              `Inventory-${this.dataset.section}`,
            );

            if (source && destination) destination.innerHTML = source.innerHTML;
            if (inventorySource && inventoryDestination)
              inventoryDestination.innerHTML = inventorySource.innerHTML;
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle(
                "visibility-hidden",
                skuSource.classList.contains("visibility-hidden"),
              );
            }

            // Update measurements (dimensions from variant metafields)
            const measurementsSource = html.getElementById(
              `Measurements-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`,
            );
            const measurementsDestination = document.getElementById(
              `Measurements-${this.dataset.section}`,
            );
            if (measurementsDestination) {
              if (measurementsSource && measurementsSource.innerHTML.trim() !== "") {
                measurementsDestination.innerHTML = measurementsSource.innerHTML;
                measurementsDestination.classList.remove("visibility-hidden");
              } else {
                measurementsDestination.innerHTML = "";
                measurementsDestination.classList.add("visibility-hidden");
              }
            }

            const price = document.getElementById(
              `price-${this.dataset.section}`,
            );

            if (price) price.classList.remove("visibility-hidden");

            if (inventoryDestination)
              inventoryDestination.classList.toggle(
                "visibility-hidden",
                inventorySource.innerText === "",
              );

            this.checkSizeSelection();

            publish(PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId: sectionId,
                html,
                variant: this.currentVariant
              },
            });
          });
      }

      initialize() {
        if (this.hasInitialized) return;

        this.hasInitialized = true;
        this.form = document.querySelector(`#product-form-${this.dataset.section}`);

        this.updateOptions();
        this.updateMasterId();
        this.updateGallery();
        this.updateVariantStatuses();
        this.updateDropdownButtons();
        this.checkSizeSelection();
        this.setupSizeVerification();
        this.setupLowStockTooltip();

        if (typeof this.verifyComingSoon === 'function') this.verifyComingSoon();
        if (typeof this.toggleHistoryState === 'function') this.toggleHistoryState();
        if (typeof this.updateUrl === 'function') this.updateUrl(this.currentVariant);
      }

      setupSizeVerification() {
        const sizeInputs = this.querySelectorAll('input[type="radio"][data-option-type="size"]');

        sizeInputs.forEach(input => {
          input.addEventListener('change', () => {
            try {
              this.checkSizeSelection();
            } catch {
              // Silently fail or log generic error
            }
          });
        });

        // Initial check
        this.checkSizeSelection();
      }

      checkSizeSelection() {
        console.log('[BRN-DEBUG] checkSizeSelection() called');

        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) {
          console.log('[BRN-DEBUG] No productForm found for section:', this.dataset.section);
          return;
        }

        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        if (!addButton) {
          console.log('[BRN-DEBUG] No addButton found');
          return;
        }

        // Check for size options using data-option-type attribute
        const allSizeInputs = Array.from(this.querySelectorAll('input[type="radio"][data-option-type="size"]'));
        let hasSizeOption = allSizeInputs.length > 0;
        let sizeSelected = allSizeInputs.some(input => input.checked);

        console.log('[BRN-DEBUG] Size inputs found:', allSizeInputs.length);
        console.log('[BRN-DEBUG] hasSizeOption:', hasSizeOption, 'sizeSelected:', sizeSelected);
        console.log('[BRN-DEBUG] currentVariant:', this.currentVariant);

        let isSingleUSizeOption = false;

        if (allSizeInputs.length === 1) {
          const singleValue = allSizeInputs[0].value || '';
          if (singleValue.toUpperCase() === 'U') {
            isSingleUSizeOption = true;
            if (!allSizeInputs[0].checked) {
              allSizeInputs[0].checked = true;
              sizeSelected = true;

            }
          }
        }

        // Single U Logic
        if (isSingleUSizeOption) {
          hasSizeOption = false; // Bypass size logic for Single U
          if (this.currentVariant) {
            if (this.currentVariant.available) {
              addButton.removeAttribute('disabled');
            } else {
              addButton.setAttribute('disabled', 'disabled');
              if (addButtonText) addButtonText.textContent = window.variantStrings?.soldOut || 'Agotado';
            }
          }
          return;
        }

        // Sticky button
        const stickyButton = document.querySelector('.wt-product__sticky-buy__btn');
        const stickyButtonText = stickyButton ? stickyButton.querySelector('[data-add-to-cart-text]') : null;

        // Normal Size Logic
        if (hasSizeOption && !sizeSelected) {
          addButton.setAttribute('disabled', 'disabled');
          if (addButtonText) addButtonText.textContent = window.variantStrings?.addToCart || 'Añadir al carrito';

          // Sticky button must remain enabled to allow scroll-to-top interaction
          if (stickyButton) {
            stickyButton.removeAttribute('disabled');
            if (stickyButtonText) stickyButtonText.textContent = window.variantStrings?.addToCart || 'Añadir al carrito';
          }
        } else if (hasSizeOption && sizeSelected) {
          addButton.removeAttribute('disabled');
          if (stickyButton) stickyButton.removeAttribute('disabled');

          // Re-check availability just in case (though updateMasterId handles it usually)
          if (this.currentVariant && !this.currentVariant.available) {
            addButton.setAttribute('disabled', 'disabled');
            if (addButtonText) addButtonText.textContent = window.variantStrings?.soldOut || 'Agotado';

            if (stickyButton) {
              stickyButton.setAttribute('disabled', 'disabled');
              if (stickyButtonText) stickyButtonText.textContent = window.variantStrings?.soldOut || 'Agotado';
            }
          } else {
            if (addButtonText) addButtonText.textContent = window.variantStrings?.addToCart || 'Añadir al carrito';
            if (stickyButton && stickyButtonText) stickyButtonText.textContent = window.variantStrings?.addToCart || 'Añadir al carrito';
          }
        } else {
          // No size options
        }
      }
      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        if (!productForm) return;

        // Main button
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');

        // Sticky button
        const stickyButton = document.querySelector('.wt-product__sticky-buy__btn');
        const stickyButtonText = stickyButton ? stickyButton.querySelector('[data-add-to-cart-text]') : null;

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");
          if (text) addButtonText.textContent = text;

          if (stickyButton) {
            stickyButton.setAttribute("disabled", "disabled");
            if (text && stickyButtonText) stickyButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute("disabled");
          addButtonText.textContent = window.variantStrings.addToCart;

          if (stickyButton) {
            stickyButton.removeAttribute("disabled");
            if (stickyButtonText) stickyButtonText.textContent = window.variantStrings.addToCart;
          }
        }

        if (!modifyClass) return;
      }

      setUnavailable() {
        console.log('[BRN-DEBUG] setUnavailable() called');
        const button = document.getElementById(
          `product-form-${this.dataset.section}`,
        );
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const measurements = document.getElementById(`Measurements-${this.dataset.section}`);

        if (!addButton) return;
        // Prevent flicker: if a size is selected, don't override CTA
        const hasSelectedSize = this.querySelector('input[type="radio"][data-option-type="size"]:checked') !== null;
        console.log('[BRN-DEBUG] setUnavailable - hasSelectedSize:', hasSelectedSize);
        if (!hasSelectedSize) {
          console.log('[BRN-DEBUG] Setting button text to unavailable');
          addButtonText.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'No disponible';
        }
        if (price) price.classList.add("visibility-hidden");
        if (inventory) inventory.classList.add("visibility-hidden");
        if (sku) sku.classList.add("visibility-hidden");
        if (measurements) measurements.classList.add("visibility-hidden");
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent,
          );
        return this.variantData;
      }

      constructCombinedHandle(colorValue) {
        const currentHandle = this.dataset.productHandle;

        const colorSlug = colorValue.toLowerCase()
          .replace(/\s+/g, '-')
          .replace(/[^a-z0-9-]/g, '');

        const patterns = [
          currentHandle.replace(/-[a-z-]+$/, `-${colorSlug}`),
          `${currentHandle}-${colorSlug}`,
          colorSlug
        ];

        return patterns[0];
      }

      setupLowStockTooltip() {
        const tooltips = this.querySelectorAll('.variant-tooltip[data-low-stock="true"]');
        tooltips.forEach((tooltip) => {
          const label = tooltip.previousElementSibling;
          if (!label) return;
          const show = () => tooltip.classList.add('show');
          const hide = () => tooltip.classList.remove('show');
          label.addEventListener('mouseenter', show);
          label.addEventListener('mouseleave', hide);
          label.addEventListener('focus', show, true);
          label.addEventListener('blur', hide, true);
        });
      }
    },
  );
}
